// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3jEfU","savePackageButton":"ClientWallet_savePackageButton__3871X"};